import { useState } from 'react';
import useIsomorphicLayoutEffect from './useIsomorphicLayoutEffect';
// import { isDesktop } from './useIsDesktopDevice';

export function useClientOnly(): boolean {
  const [isClientOnly, setIsClientOnly] = useState(false);

  useIsomorphicLayoutEffect(() => {
    setIsClientOnly(true);
  }, []);

  return isClientOnly;
}
